import React, { useRef } from "react";
import PropTypes from "prop-types";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { useLocation } from "react-router";

import "./StaggeredAnimation.css";

export function StaggeredAnimation({ animationKey, children, onAnimationEnd }) {
  const { pathname } = useLocation();

  const childList = React.Children.toArray(children);
  const nodeRef = useRef(null); // https://github.com/reactjs/react-transition-group/issues/668
  const isPdfMode = pathname.startsWith("/pdf/");

  return (
    <SwitchTransition>
      <CSSTransition
        key={animationKey}
        appear={true}
        timeout={400}
        classNames="staggered-animation"
        nodeRef={nodeRef}
      >
        <div className="staggered-animation" ref={nodeRef}>
          {childList
            .filter((child) => !!child) // filter out empty children
            .map((child, i, visibleChildren) => {
              const className = child.props.className
                ? `${child.props.className} staggered-animation__item`
                : "staggered-animation__item";

              const isLastChild = i === visibleChildren.length - 1;

              // The offset is 0 to avoid an animation when the pdf is generated
              const animationOffsetY = isPdfMode ? 0 : 2;
              return React.cloneElement(child, {
                className,
                style: {
                  transform: `translateY(${(i + 1) * animationOffsetY}rem)`,
                },
                ...(isLastChild && onAnimationEnd && { onAnimationEnd }),
              });
            })}
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
}

StaggeredAnimation.propTypes = {
  children: PropTypes.node,
  animationKey: PropTypes.string.isRequired,
  onAnimationEnd: PropTypes.func,
};
